<!-- eslint-disable -->
<template lang="pug">
    .battle-stage
        .battle-stage__header-block
            .battle-stage-header
                .battle-stage-header__grid-col
                    .battle-stage-header__title
                        | {{ $i18n.t('olympiads.olympiads_stageForm_stage') }} &nbsp;
                        span(v-text="stageIndex + 1")
                .battle-stage-header__grid-col.battle-stage-header__grid-col--narrow
                    cs-button.battle-stage-header__circle-button(
                        pattern="primary-outline",
                        @click="$emit('upStage', stageIndex)"
                    )
                        svg-icon(name="angle-up", middle)
                    cs-button.battle-stage-header__circle-button(
                        pattern="primary-outline",
                        @click="$emit('downStage', stageIndex)"
                    )
                        svg-icon(name="angle-down", middle)
                    cs-button.battle-stage-header__circle-button(
                        pattern="primary-outline",
                        @click="$emit('removeStage', stageIndex)"
                    )
                        svg-icon(name="times", middle)
            .battle-stage__grid(v-for="index in gamesLength")
                .battle-stage__block
                    .battle-stage__label
                        | {{ index === 1 ? $i18n.t('homework.homework_create_chooseGames') : ' ' }}
                    .battle-stage__block-body
                        cs-multiselect(
                            :multiple="false",
                            :options="availableGames",
                            :show-labels="false",
                            :allow-empty="false",
                            :placeholder="games.length === 0 ? '' : $i18n.t('course.course_form_chooseGamesPlaceholder')",
                            :disabled="games.length === 0",
                            label="name",
                            :value="stage.games[index - 1]",
                            @select="gameHandler($event, index - 1)"
                        )
        .battle-stage__game-preview(v-for="(game, index) in stage.games")
            .battle-game-header
                .battle-game-header__grid-col
                    .battle-game-header__title
                        img.battle-game-header__image(:src="`/imgs/game-icons/${game.slug}.png`")
                        .battle-game-header__title-text
                            p.battle-game-header__subtitle
                                | {{ $i18n.t('olympiads.olympiads_stageForm_game') }}
                                |
                                | {{ index + 1 }}
                            span.battle-game-header__name(v-text="getGameName(game)")
                .battle-game-header__grid-buttons-col
                    cs-button.battle-stage-header__circle-button(
                        pattern="primary-outline",
                        @click="upGame(index)"
                    )
                        svg-icon(name="angle-up", middle)
                    cs-button.battle-stage-header__circle-button(
                        pattern="primary-outline",
                        @click="downGame(index)"
                    )
                        svg-icon(name="angle-down", middle)
                    cs-button.battle-stage-header__circle-button(
                        pattern="primary-outline",
                        @click="stage.games.splice(index, 1)"
                    )
                        svg-icon(name="times", middle)
            .battle-game-settings
                .battle-game-settings__button-container
                    cs-button.battle-game-settings__button(pattern="primary-outline", narrow, color="blue", @click="editGame(index)")
                        svg-icon.battle-game-settings__button-item(name="cog")
                        =" "
                        span.battle-game-settings__button-item {{ $i18n.t('olympiads.olympiads_stageForm_tune') }}
                    span.help.is-danger(v-show="errors.has('game_' + index)" v-text="errors.first('game_' + index)")
                .battle-game-settings__parameters
                    div(v-if="game.parameters.default", :is="getPreview(game.slug)", :game="game", :with-icon="false")
                    template(v-else)
                        .row
                            .col-sm-6
                                svg-icon(name="exclamation-circle")
                            .col-sm-6 {{ $i18n.t('olympiads.olympiads_stageForm_configureTheParameters') }}
            divider(v-if="index + 1 !== stage.games.length")
        hr.battle-stage__divider
</template>

<script>
    /*eslint-disable*/
    import TrainerUtilities from '../../utils/trainer/trainer';
    import { getInitParameters } from '../../utils/trainer/getInitParameters';
    const AddSubPreview = () => import('../games/games-previews/AddSubPreview.vue');
    const FlashCardsPreview = () => import('../games/games-previews/FlashCardsPreview.vue');
    const MultDivPreview = () => import('../games/games-previews/MultDivPreview.vue');
    const EquationPreview = () => import('../games/games-previews/EquationPreview.vue');
    const AnzanPreview = () => import('../games/games-previews/AnzanPreview.vue');
    const PuzzlePreview = () => import('../games/games-previews/PuzzlePreview.vue');
    const CouplesPreview = () => import('../games/games-previews/CouplesPreview.vue');
    const ChainsPreview = () => import('../games/games-previews/ChainsPreview.vue');
    const ScannerPreview = () => import('../games/games-previews/ScannerPreview.vue');
    const WordsFieldPreview = () => import('../games/games-previews/WordsFieldPreview.vue');
    const AnagramsPreview = () => import('../games/games-previews/AnagramsPreview.vue');
    const TextsPreview = () => import('../games/games-previews/TextsPreview.vue');
    const LettersFieldPreview = () => import('../games/games-previews/LettersFieldPreview.vue');
    const CatchWordPreview = () => import('../games/games-previews/CatchWordPreview.vue');
    const VisionFieldPreview = () => import('../games/games-previews/VisionFieldPreview.vue');
    const SchultePreview = () => import('../games/games-previews/SchultePreview.vue');
    const MatrixPreview = () => import('../games/games-previews/MatrixPreview.vue');
    const NavigatorPreview = () => import('../games/games-previews/NavigatorPreview.vue');
    const SynonymsPreview = () => import('../games/games-previews/SynonymsPreview.vue');
    const TransferSyllablesPreview = () => import('../games/games-previews/TransferSyllablesPreview.vue');
    const HardSoftConsonantsPreview = () => import('../games/games-previews/HardSoftConsonantsPreview.vue');
    const DivideItRightPreview = () => import('../games/games-previews/DivideItRightPreview.vue');
    const ChooseItRightPreview = () => import('../games/games-previews/ChooseItRightPreview.vue');
    const DivideUnstressedVowelsPreview = () => import('../games/games-previews/DivideUnstressedVowelsPreview.vue');
    const VocabularyWordsRusPreview = () => import('../games/games-previews/VocabularyWordsRusPreview.vue');
    const TranscriptionInWordPreview = () => import('../games/games-previews/TranscriptionInWordPreview.vue');
    const LettersSoundsSyllablesPreview = () => import('../games/games-previews/LettersSoundsSyllablesPreview.vue');
    const VoicedAndDeafConsonantsPreview = () => import('../games/games-previews/VoicedAndDeafConsonantsPreview.vue');
    const PartsOfSpeechPreview = () => import('../games/games-previews/PartsOfSpeechPreview.vue');
    const ParsingSentencePartsSpeechPreview = () => import('../games/games-previews/ParsingSentencePartsSpeechPreview.vue');
    const GenericWordsPreview = () => import('../games/games-previews/GenericWordsPreview.vue');
    const VerbTensesPreview = () => import('../games/games-previews/VerbTensesPreview.vue');
    const WordStructurePreview = () => import('../games/games-previews/WordStructurePreview.vue');
    const SentenceParsingPreview = () => import('../games/games-previews/SentenceParsingPreview.vue');
    const SortOneManyPreview = () => import('../games/games-previews/SortOneManyPreview.vue');
    const PunctuationMarksPreview = () => import('../games/games-previews/PunctuationMarksPreview.vue');
    const AlphabetPreview = () => import('../games/games-previews/AlphabetPreview.vue');
    const ConnectThePuzzlesPreview = () => import('../games/games-previews/ConnectThePuzzlesPreview.vue');
    const OrthographPreview = () => import('../games/games-previews/OrthographPreview.vue');

    import { mapState } from 'vuex';
    import _ from 'lodash';

    export default {
        props: {
            games: {
                type: Array,
                default() {
                    return [];
                },
            },
            stage: {
                type: Object,
                default() {
                    return {};
                },
            },
            stageIndex: {
                type: Number,
                default: 0,
            },
            isTrainer: {
                type: Boolean,
                default: false,
            },
        },
        mixins: [TrainerUtilities],
        computed: {
            ...mapState({
                battle: state => state.battle.battle,
            }),
            gamesLength() {
                return this.stage.games.length + 1;
            },
            availableGames() {
                return this.games.filter(game => this.availableGamesForBattle.includes(game.slug));
            },
        },
        methods: {
            gameHandler(game, index) {
                this.$set(this.stage.games, index, _.cloneDeep(game));
                this.stage.games[index].parameters.default = getInitParameters(this.stage.games[index]);
            },
            getPreview(game) {
                switch (game) {
                    case 'MultiplicationAndDivision':
                        return 'mult-div-preview';
                    case 'FlashCards':
                    case 'InteractiveFlashCards':
                        return 'flash-cards-preview';
                    case 'AdditionAndSubtraction':
                    case 'AdditionAndSubtractionWithTime':
                        return 'add-sub-preview';
                    case 'Equation':
                        return 'equation-preview';
                    case 'Anzan':
                        return 'anzan-preview';
                    case 'Puzzle':
                        return 'puzzle-preview';
                    case 'Chains':
                        return 'chains-preview';
                    case 'Couples':
                        return 'couples-preview';
                    case 'Schulte':
                        return 'schulte-preview';
                    case 'Scanner':
                        return 'scanner-preview';
                    case 'Anagrams':
                        return 'anagrams-preview';
                    case 'WordsField':
                        return 'words-field-preview';
                    case 'Texts':
                        return 'texts-preview';
                    case 'LettersField':
                        return 'letters-field-preview';
                    case 'CatchWord':
                        return 'catch-word-preview';
                    case 'Matrix':
                        return 'matrix-preview';
                    case 'Navigator':
                        return 'Navigator-preview';
                    case 'Synonyms':
                        return 'synonyms-preview';
                    case 'VisionField':
                        return 'vision-field-preview';
                    case 'TransferSyllables':
                        return 'transfer-syllables-preview';
                    case 'HardSoftConsonants':
                        return 'hard-soft-consonants-preview';
                    case 'DivideItRight':
                        return 'divide-it-right-preview';
                    case 'ChooseItRight':
                        return 'choose-it-right-preview';
                    case 'DivideUnstressedVowels':
                        return 'divide-unstressed-vowels-preview';
                    case 'VocabularyWordsRus':
                        return 'vocabulary-words-rus-preview';
                    case 'TranscriptionInWord':
                        return 'transcription-in-word-preview';
                    case 'LettersSoundsSyllables':
                        return 'letters-sounds-syllables-preview';
                    case 'VoicedAndDeafConsonants':
                        return 'voiced-and-deaf-consonants-preview';
                    case 'PartsOfSpeech':
                        return 'parts-of-speech-preview';
                    case 'ParsingSentencePartsSpeechPreview':
                        return 'parsing-sentence-parts-speech-preview';
                    case 'GenericWords':
                        return 'generic-words-preview';
                    case 'VerbTenses':
                        return 'verb-tenses-preview';
                    case 'WordStructure':
                        return 'word-structure-preview';
                    case 'SentenceParsing':
                        return 'sentence-parsing-preview';
                    case 'SortOneMany':
                        return 'sort-one-many-preview';
                    case 'PunctuationMarks':
                        return 'punctuation-marks-preview';
                    case 'Alphabet':
                        return 'alphabet-preview';
                    case 'ConnectThePuzzles':
                        return 'connect-the-puzzles-preview';
                    case 'Orthograph':
                        return 'orthograph-preview';
                }
            },
            upGame(index) {
                if (index !== 0) {
                    this.stage.games.splice(index - 1, 0, this.stage.games.splice(index, 1)[0]);
                }
            },
            downGame(index) {
                if (index !== this.stage.games.length - 1) {
                    this.stage.games.splice(index + 1, 0, this.stage.games.splice(index, 1)[0]);
                }
            },
            editGame(index) {
                let gamesParameters = {};
                let game = _.find(this.games, { slug: this.stage.games[index].slug });
                let slug = game.slug;
                gamesParameters[slug] = game.parameters.default;
                this.$store.dispatch('setGamesParameters', _.cloneDeep(gamesParameters));
                let routeParams = {
                    battleId: this.$route.params.battleId,
                    index: this.$route.params.index,
                    stageId: this.stageIndex,
                    id: index,
                };
                let routeName = this.isTrainer ? 'battle-training-stage-game:edit' : 'battle-stage-game:edit';
                if (slug === 'Puzzle') {
                    this.$router.replace({ name: routeName, params: routeParams });
                } else {
                    this.$router.push({ name: routeName, params: routeParams });
                }
            },
        },
        data() {
            return {
                availableGamesForBattle: [
                    'Schulte',
                    'AdditionAndSubtraction',
                    'Navigator',
                    'InteractiveFlashCards',
                    'AdditionAndSubtractionWithTime',
                    'Anzan',
                    'MultiplicationAndDivision',
                    'Puzzle',
                    'Equation',
                    'TransferSyllables',
                    'HardSoftConsonants',
                    'DivideItRight',
                    'ChooseItRight',
                    'DivideUnstressedVowels',
                    'VocabularyWordsRus',
                    'TranscriptionInWord',
                    'LettersSoundsSyllables',
                    'VoicedAndDeafConsonants',
                    'PartsOfSpeech',
                    'ParsingSentencePartsSpeech',
                    'GenericWords',
                    'VerbTenses',
                    'WordStructure',
                    'SentenceParsing',
                    'SortOneMany',
                    'PunctuationMarks',
                    'Alphabet',
                    'ConnectThePuzzles',
                    'Orthograph',
                ],
            };
        },
        components: {
            AddSubPreview,
            FlashCardsPreview,
            MultDivPreview,
            EquationPreview,
            AnzanPreview,
            PuzzlePreview,
            ChainsPreview,
            CouplesPreview,
            SchultePreview,
            ScannerPreview,
            WordsFieldPreview,
            AnagramsPreview,
            TextsPreview,
            LettersFieldPreview,
            CatchWordPreview,
            MatrixPreview,
            NavigatorPreview,
            SynonymsPreview,
            VisionFieldPreview,
            TransferSyllablesPreview,
            HardSoftConsonantsPreview,
            DivideItRightPreview,
            ChooseItRightPreview,
            DivideUnstressedVowelsPreview,
            VocabularyWordsRusPreview,
            TranscriptionInWordPreview,
            LettersSoundsSyllablesPreview,
            VoicedAndDeafConsonantsPreview,
            PartsOfSpeechPreview,
            ParsingSentencePartsSpeechPreview,
            GenericWordsPreview,
            VerbTensesPreview,
            WordStructurePreview,
            SentenceParsingPreview,
            SortOneManyPreview,
            PunctuationMarksPreview,
            AlphabetPreview,
            ConnectThePuzzlesPreview,
            OrthographPreview,
        },
    };
</script>

<style lang="scss" scoped>
    .battle-stage {
        width: 100%;
    }

    .battle-stage-header,
    .battle-game-header {
        @include make-grid;
        @include stack-space($space-small);
        @include inset-space($space-xx-small);
        align-items: center;
        justify-content: space-between;
    }

    .battle-game-header {
        margin: 0;
        flex-direction: column;
        align-items: flex-start;
        @include media($md) {
            flex-direction: row;
            margin-bottom: 15px;
        }
    }

    .battle-stage-header__title {
        white-space: nowrap;
        font-weight: 500;
        font-size: 18px;
        @include stack-space($space-base);
        padding-right: 10%;
        margin-top: 5px;
    }

    .battle-stage-header__grid-col,
    .battle-game-header__grid-col {
        @media screen and (min-width: 768px) and (max-width: 992px) {
            width: 50%;
        }
    }

    .battle-stage-header__grid-col--narrow,
    .battle-game-header__grid-col--header {
        text-align: right;
    }

    .battle-stage-header__circle-button {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        margin: $space-xx-small;
        border-radius: 50%;
        width: 2em;
        height: 2em;
        padding: 0 !important;
    }

    .battle-stage__header-block {
        @include inset-space($space-small);
        @include stack-space($space-base);
    }

    .battle-stage__grid {
        @include make-grid;
        @include media($lg) {
            margin-left: auto;
            width: 85%;
        }
        @include media($xl) {
            width: 70%;
        }
    }

    .battle-stage__block {
        margin-bottom: 20px;
        @include make-col;
        padding-right: 0;
        display: flex;
        @media screen and (max-width: 767px) {
            padding-left: 0;
            flex-wrap: wrap;
            margin-bottom: 0;
            max-width: 100%;
            :first-child {
                @include stack-space($space-base);
            }
        }
    }

    .battle-stage__label {
        min-width: 8em;
        font-size: 16px;
        line-height: 19px;
        text-align: left;
        margin-right: 10px;
        align-self: center;
    }

    .battle-stage__block-body {
        flex-grow: 5;
        @media screen and (max-width: 767px) {
            width: 100%;
        }
    }

    .battle-stage__game-preview {
        @include inset-space($space-small);
    }

    .battle-game-header__title {
        flex-direction: row;
        @include make-grid(0);
    }

    .battle-game-header__image {
        vertical-align: middle;
        min-height: 30px;
        margin: 0 10px 10px 0;
        @include media($sm) {
            @include inline-space($space-small);
        }
        @include media($lg) {
            min-height: 45px;
        }
    }

    .battle-game-header__title-text {
        vertical-align: middle;
        display: inline-block;
    }

    .battle-game-header__subtitle {
        @include stack-space($space-x-small);
    }

    .battle-game-header__name {
        font-size: $font-size-16;
    }

    .battle-game-header__grid-buttons-col {
        text-align: left;
        margin: 10px 0;
        @include media($sm) {
            text-align: right;
        }
        @include media($md) {
            margin: 10px 0 0 10px;
        }
    }

    .battle-game-settings {
        @include make-grid($space-small);
        @include stack-space($space-small);
        flex-direction: column;
        @include media($md) {
            flex-direction: row;
        }
    }

    .battle-game-settings__button-container {
        @include inset-space($space-x-small);
        margin: 0 auto 0 0;
        @include media($md) {
            margin: 0 15px 0 0;
        }
    }

    .battle-game-settings__parameters {
        @include inset-space($space-x-small);
        @include media($md) {
            width: 50%;
        }
    }

    .battle-game-settings__button {
        padding: 10px 30px !important;
        font-size: 16px !important;
        font-weight: 500 !important;
    }

    .battle-game-settings__button-item {
        vertical-align: middle;
        margin-right: 8px;
    }
</style>
